module.exports = __webpack_public_path__ + "static/media/Instagram.e8b623c6.png";